import { DEFAULT_HEADER_HEIGHT, DEFAULT_ROW_HEIGHT } from '../../constants/data-grid';
import {
  ONBOARDING_TABLE_CLASS_NAME,
  DEFAULT_TABLE_CLASS_NAME,
  ONBOARDING_LAST_TABLE_CELL_CLASS_NAME,
  DETAILED_FINGO_TABLE_CLASS_NAME,
} from '../../constants/table';

const defaultFingoTable = () => ({
  borderCollapse: 'separate',
  borderSpacing: '0 10px',
  marginTop: -10,
});

const onboardingFingoTable = () => ({
  borderCollapse: 'separate',
  borderSpacing: '0 24px',
  marginTop: -24,
  [`& .${ONBOARDING_LAST_TABLE_CELL_CLASS_NAME}`]: {
    paddingRight: 16,
  },
});

const detailedFingoTable = ({ theme }) => ({
  borderCollapse: 'separate',
  borderSpacing: 0,
  marginTop: 0,
  border: `1px solid ${theme.palette.gray.A200}`,
  borderRadius: 12,
  overflow: 'hidden',
  '& .MuiTableHead-root': {
    '& .MuiTableRow-root': {
      height: DEFAULT_HEADER_HEIGHT,
    },
    '& .MuiTableCell-root': {
      backgroundColor: `${theme.palette.gray.A100}`,
      borderBottom: `1px solid ${theme.palette.gray.A400} !important`,
      padding: '0 16px',
      borderBottomLeftRadius: '0',
      borderBottomRightRadius: '0',
      '& .MuiTableSortLabel-root': {
        color: theme.palette.gray.A800,
        fontSize: theme.typography.small_2.fontSize,
        fontWeight: 600,
        lineHeight: 'normal',
        '&.Mui-active': {
          color: theme.palette.gray.A800,
        },
        '& .MuiTableSortLabel-icon': {
          color: theme.palette.gray.A800,
        },
      },
    },
  },
  '& .MuiTableBody-root .MuiTableRow-root': {
    backgroundColor: theme.palette.common.white,
    height: DEFAULT_ROW_HEIGHT,
  },
  '& .MuiTableBody-root .MuiTableCell-root': {
    borderBottom: `1px solid ${theme.palette.gray.A300} !important`,
    borderRadius: '0',
    paddingLeft: 16,
    paddingRight: 16,
  },
});

const MuiTable = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${DEFAULT_TABLE_CLASS_NAME}`]: defaultFingoTable(),
      [`&.${ONBOARDING_TABLE_CLASS_NAME}`]: onboardingFingoTable(),
      [`&.${DETAILED_FINGO_TABLE_CLASS_NAME}`]: detailedFingoTable({ theme }),
    }),
  },
};

export default MuiTable;
